import React from 'react';

import initReactApp from 'dpl/util/initReactApp';
import GlobalMobileMenuNavigationButtonContainer from 'dpl/containers/GlobalMobileMenu/GlobalMobileMenuNavigationButtonContainer';
import MobileNavigationMenuContainer from 'dpl/join_as_breeder/containers/MobileNavigationMenuContainer';
import PuppyCollegeQuoteContainer from 'dpl/puppy_college/containers/PuppyCollegeQuoteContainer';
import TrustSection from 'dpl/common/components/TrustSection';
import PuppyCollegeGetStartedLink from 'dpl/puppy_college/components/PuppyCollegeGetStartedLink';
import PuppyCollegeEducationTiles from 'dpl/puppy_college/components/PuppyCollegeEducationTiles';
import PuppyCollegeMission from 'dpl/puppy_college/components/PuppyCollegeMission';
import PuppyCollegeBenefits from 'dpl/puppy_college/components/PuppyCollegeBenefits';

initReactApp({
  MobileNavigationMenuContainer,
  /* eslint-disable react/display-name */
  MobileNavigationMenuButton: () => (
    <GlobalMobileMenuNavigationButtonContainer />
  ),
  BreederApplicationContainer: () => (
    <PuppyCollegeGetStartedLink
      variant="white"
      className="w-100 w-auto-ns dib font-16 pv3 ph8 ph12-xl bw0 br2"
    />
  ),
  PuppyCollegeNavigationApplicationContainer: () => (
    <PuppyCollegeGetStartedLink className="w-100 w-auto-ns pv3" />
  ),
  PuppyCollegeQuoteContainer,
  PuppyCollegeEducationTiles,
  PuppyCollegeBenefits,
  PuppyCollegeMission,
  /* eslint-enable react/display-name */
  TrustSection
});
